import IngredientImageUpload from "../../ingredientRegister/components/IngredientImageUpload";
import { IngredientRegisterViewModel } from "../../ingredientRegister/types/ingredientRegisterView.types";
import { Card, CardContent, CardHeader } from "../../../../components/ui/common/card";
import { Input } from "../../../../components/ui/common/input";
import { Label } from "../../../../components/ui/common/label";

interface IngredientEditInfoCardProps {
  vm: IngredientRegisterViewModel;
}

/**
 * "INGREDIENT INFO" card for the edit flow — unlike the register flow's
 * `IngredientInfoCard`, Ingredient Name and Supplier Name aren't a
 * search-select (editing never re-picks a different ingredient/supplier
 * link); Supplier Name stays read-only, but Ingredient Name is an editable
 * text field so the user can rename the ingredient — `vm.onIngredientNameChange`
 * updates the edit view-model's ingredient data, which `onSave` already
 * includes in every PUT /ingredient payload. The image is editable too,
 * uploading/deleting immediately rather than staging.
 */
const IngredientEditInfoCard = ({ vm }: IngredientEditInfoCardProps) => {
  return (
    <Card className="tw-gap-3 tw-py-4">
      <CardHeader className="tw-px-4">
        <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground">
          Ingredient Info
        </span>
      </CardHeader>
      <CardContent className="tw-flex tw-flex-col tw-gap-3 tw-px-4">
        <div className="tw-grid tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-2">
          <div className="tw-flex tw-flex-col tw-gap-1.5">
            <Label>Ingredient Name</Label>
            <Input
              value={vm.ingredientData?.ingredient_name || ""}
              onChange={e => vm.onIngredientNameChange?.(e.target.value)}
              placeholder="Ingredient name"
            />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-1.5">
            <Label>Supplier Name</Label>
            <Input value={(vm.supplierData?.supplier_name as string) || ""} disabled readOnly />
          </div>
        </div>

        <div>
          <Label>Ingredient Image</Label>
          <div className="tw-mt-1.5">
            <IngredientImageUpload
              imagePath={vm.imagePath}
              onUpload={vm.onImageUpload}
              onDelete={vm.onImageDelete}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default IngredientEditInfoCard;
